export type FileNode = {
    id: number; // Unique identifier for the node
    uuid: string; // UUID string
    text: string; // File name, e.g., "E5_Pistepilvi_01.laz"
    type: 'file' | 'folder'; // Node type
    depth: number; // Depth in the tree
};

export const pointCloudFilter = (item: FileNode): boolean => {
    if (!item.text) return false;
    const extension: string = item.text.split('.').pop();
    return extension === 'las' || extension === 'laz' || extension === 'e57';
};

export function extractTokenExpiration(decodedToken: string): number {
    // Match all JSON objects in the string
    const matches = decodedToken.match(/{[^}]+}/g);
    if (!matches || matches.length < 2) return null;
    try {
        const payload = JSON.parse(matches[1]);
        return payload.exp;
    } catch {
        return new Date().getTime() + 300; // Default to 5 minutes if parsing fails
    }
}